import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CoreLogService } from "../../../core/services/log.service";
import Utils from "../../../core/shared/utils";
import { ISOTService } from '../../services';

export interface tipDialogConfig {
  useModeOne: boolean;
  useModeTwo: boolean;
  sot_service: ISOTService;
}

@Component({
  selector: "sot-tipdialog",
  templateUrl: "./tipdialog.component.html",
  styleUrls: ["./tipdialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TipDialogComponent {
  private _sotService: ISOTService;
  private _tipping_percent: number = 0;
  public get tipping_percent(): number {
    return this._tipping_percent;
  }
  public basketprice: number;
  public tipAmount: number;
  public totalPrice: number;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , public dialogRef: MatDialogRef<TipDialogComponent, number>
    , @Inject(MAT_DIALOG_DATA) data: number
    , @Inject(MAT_DIALOG_DATA) public tipDialogConfig: tipDialogConfig
    , private _coreLogService: CoreLogService) {
    const me = this;
    me.basketprice = data["basketprice"];
    me.setTipAmount();
    me.setTotalPrice();
    me._sotService = tipDialogConfig.sot_service;
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("TipDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }
  public ngOnInit(): void {
    const me = this;
    me.PushChanges();
  }
  public setTipAmount(): number {
    const me = this;
    return me.tipAmount = Utils.moneyRound(me.basketprice * (me._tipping_percent / 100.0));
  }
  public get isModeOne(): boolean {
    return this.tipDialogConfig.sot_service.Accessabilty.useModeOne;
  }
  public get isModeTwo(): boolean {
    return this.tipDialogConfig.sot_service.Accessabilty.useModeTwo;
  }
  public setTotalPrice(): number {
    const me = this;
    return me.totalPrice = Utils.moneyRound(me.basketprice + me.tipAmount);
  }

  public setTipping(tip: number) {
    const me = this;
    me._tipping_percent = tip;
    me.setTipAmount();
    me.setTotalPrice();
    me.PushChanges();
  }

  public closeTip() {
    this.dialogRef.close(this._tipping_percent);
  }
}
